import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripHtml',
    standalone: true,
})

export class StripHtmlPipe implements PipeTransform {
    transform(value: string, limit :number, ellipsis = '...'): string {
    if (!value) return '';
     // Remove HTML tags
    let cleaned = value.replace(/<\/?[^>]+(>|$)/g, '');
    //Decode HTML entities (&nbsp;, &amp;, etc.)
    if (typeof document !== 'undefined') {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = cleaned;
    cleaned = textarea.value;
    // Truncate
    }
    return cleaned?.length > limit ? cleaned.substring(0, limit) + ellipsis : cleaned;
    }
}